import { InitialsAvatar, getInitials } from "./InitialsAvatar";
import { resolveAvatarUrl } from "../lib/avatar";

/**
 * Shows uploaded avatar image when avatar_url is set; otherwise initials fallback.
 * @param {boolean} embedded - Fill parent circle exactly (header/settings); no extra ring/border.
 */
export function UserAvatar({ name, avatarUrl, className = "h-10 w-10", accentColor, alt, embedded = false }) {
    const src = resolveAvatarUrl(avatarUrl);

    if (embedded) {
        const merged = className || "size-full";
        if (src) {
            return (
                <img
                    key={src}
                    src={src}
                    alt={alt || name || "Avatar"}
                    decoding="async"
                    draggable={false}
                    className={`block min-h-0 min-w-0 object-cover ${merged}`}
                />
            );
        }
        return (
            <span
                className={`flex min-h-0 min-w-0 items-center justify-center overflow-hidden rounded-full bg-[#262626] font-semibold leading-none text-white ${merged}`}
                style={accentColor ? { color: accentColor } : undefined}
                aria-hidden
            >
                {getInitials(name)}
            </span>
        );
    }

    if (src) {
        return (
            <span
                className={`inline-flex shrink-0 overflow-hidden rounded-full bg-[#262626] ring-1 ring-white/10 ${className}`}
            >
                <img
                    key={src}
                    src={src}
                    alt={alt || name || "Avatar"}
                    decoding="async"
                    draggable={false}
                    className="block h-full w-full object-cover"
                />
            </span>
        );
    }

    return <InitialsAvatar name={name} className={className} accentColor={accentColor} />;
}
